var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { isErrorHTTP } from 'boost-api/APIRestClient';
import { MembersignupAPI } from 'boost-api/boost/signup/membersignup/MembersignupAPI';
import { SnackBar } from 'common-uicomponents/components/SnackBar';
import { css, html, LitElement } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { BoostPortalStore } from '../redux/BoostPortalStore';
import { reduxBind } from 'badphraim/redux/Common';
import { litReduxBoostPortalMixin } from '../redux/LitReduxBoostPortalMixin';
import { PaymentStatus } from '../helpers/BoostPortalPaymentStatusHelper';
let BoostPortalPaymentStatus = class BoostPortalPaymentStatus extends litReduxBoostPortalMixin(LitElement) {
    constructor() {
        super(...arguments);
        this.isLoading = false;
        this.shortTerm = false;
    }
    static get is() {
        return 'boost-portal-payment-status';
    }
    static get styles() {
        return css `
            .container {
                height: 100dvh;
                width: 100dvw;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                background-color: #132c4f;
            }

            .invoice-container {
                display: flex;
                flex-direction: column;
                width: 100%;
                max-width: 600px;
                box-sizing: border-box;
                background-color: white;
                border-radius: 4px;
                padding: 3rem;
                box-shadow:
                    rgba(0, 0, 0, 0.05) 0px 6px 24px 0px,
                    rgba(0, 0, 0, 0.08) 0px 0px 0px 1px;
            }

            @media (max-width: 600px) {
                .invoice-container {
                    padding: 1.5rem;
                    height: 100dvh;
                }
            }

            .icon-container {
                background-color: rgb(230, 241, 251);
                width: 3rem;
                height: 3rem;
                border-radius: 8px;
                display: flex;
                justify-content: center;
                align-items: center;
            }

            .payment-buttons-container {
                display: flex;
                flex-direction: row;
                width: 100%;
                justify-content: space-between;
                gap: 10px;
                margin-bottom: 20px;
            }

            .payment-button {
                width: calc(50% - 5px);
                justify-content: center;
                align-items: center;
                display: flex;
                flex-direction: column;
                height: 10rem;
                border: 1px solid rgb(219, 219, 219);
                border-radius: 16px;
                box-shadow: rgba(0, 0, 0, 0.04) 0px 3px 5px;
                background-color: rgb(255, 255, 255);
                cursor: pointer;
            }

            .logo {
                width: 3rem;
                height: 3rem;
            }

            .text-container {
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
            }

            .price-text {
                font-size: 18px;
            }
        `;
    }
    connectedCallback() {
        super.connectedCallback();
        this._onConnectedCallback();
    }
    /** @override */ render() {
        return html `
            <div class="container">
                ${this.invoice
            ? this._renderInvoice()
            : html `<cerum-loading
                          type="loading-error"
                          title="${'Finner ikke faktura'}"
                      ></cerum-loading>`}
            </div>
        `;
    }
    _showCancelledPayment() {
        return html `<span style="font-size: 20px; margin-bottom: 2rem;">
            Obs! Betalingen feilet. Velg betalingsmåte og prøv på nytt
        </span> `;
    }
    _showEndedPayment() {
        return html `${!this._isCancelledExpired()
            ? html `<div
                      style="display:flex; flex-direction:row; gap: 1rem; margin-bottom:2rem; align-items:center"
                  >
                      <img style="width:3rem" src="/images/icons/check-circle.svg" />
                      <span style="font-size: 24px;">Betalingen er gjennomført</span>
                  </div>
                  <span style="font-size:18px;">Velkommen som medlem! </span> <br />
                  <span style="font-size:18px;"
                      >Medlemskapet ditt er nå aktivt og klart til bruk. Vi har sendt deg en e-post med
                      informasjon om medlemskapet og hvordan du kommer i gang.
                  </span> `
            : html `${this._showCancelledPayment()} ${this._showPaymentOptions()}`}`;
    }
    _isCancelledExpired() {
        var _a, _b, _c;
        return (((_a = this.paymentStatus) === null || _a === void 0 ? void 0 : _a.status) === PaymentStatus.TERMINATED ||
            ((_b = this.paymentStatus) === null || _b === void 0 ? void 0 : _b.status) === PaymentStatus.ABORTED ||
            ((_c = this.paymentStatus) === null || _c === void 0 ? void 0 : _c.status) === PaymentStatus.EXPIRED);
    }
    _showPaymentOptions() {
        var _a, _b;
        return html ` <div style="display: flex; gap: 1rem; align-items: center;">
                <div class="icon-container">
                    <img style="width:1.5rem" src="/images/icons/invoice-blue.svg" />
                </div>

                <span style="font-size: 24px;"
                    >${this.shortTerm ? 'Korttidsmedlemskap' : 'Løpende medlemskap'}
                </span>
            </div>
            <div style="display: flex; flex-direction: column; margin-top: 1rem;">
                ${(_a = this.invoice) === null || _a === void 0 ? void 0 : _a.invoice.linjer.map((line) => html `<div style="display: flex; justify-content: space-between">
                            <span class="price-text">${line.tittel}</span>
                            <span class="price-text">${line.sum_inc_mva},-</span>
                        </div>`)}
            </div>
            <hr style="border: none; height: 2px; background-color: #eee; width: 100%;" />
            <div style="display: flex; justify-content: space-between; margin-top: 1rem;">
                <span style="font-size: 24px;">Sum å betale:</span>
                <span class="price-text">${(_b = this.invoice) === null || _b === void 0 ? void 0 : _b.invoice.rest},-</span>
            </div>

            <div
                style="padding: 6px 1rem; border-radius: 4px; background-color: whitesmoke; margin-top: 2rem;"
            >
                <p style="text-transform: uppercase; font-weight: 500; color: dimgray; font-size:18px;">
                    Velg betalingsmåte
                </p>

                <div class="payment-buttons-container">
                    <div class="payment-button" @click="${() => this._initiatePayment('standard')}">
                        <img class="logo" src="/images/logos/main-logo.svg" />
                        <div class="text-container">
                            <p style="font-weight: 500;font-size:20px; margin:0px">Vipps</p>
                            <span style="color: dimgray;">Betal med Vipps</span>
                        </div>
                    </div>
                    <div class="payment-button" @click="${() => this._initiatePayment('card')}">
                        <img class="logo" src="/images/icons/credit-card.svg" />
                        <div class="text-container">
                            <p style="font-weight: 500;font-size:20px; margin:0px">Bankkort</p>
                            <span style="color: dimgray;">Visa / Mastercard</span>
                        </div>
                    </div>
                </div>
            </div>`;
    }
    _renderInvoice() {
        var _a, _b;
        return html `<div class="invoice-container">
            ${this.isLoading ? html `<cerum-loading type="line"></cerum-loading>` : ``}
            ${!((_a = this.paymentStatus) === null || _a === void 0 ? void 0 : _a.is_paid) && !((_b = this.paymentStatus) === null || _b === void 0 ? void 0 : _b.is_ended)
            ? this._showPaymentOptions()
            : this._showEndedPayment()}
        </div>`;
    }
    _onConnectedCallback() {
        const urlSearchParameters = new URLSearchParams(window.location.search);
        if (urlSearchParameters.has('invoiceId')) {
            this.invoiceId = Number(urlSearchParameters.get('invoiceId'));
        }
        if (urlSearchParameters.has('shortTerm')) {
            this.shortTerm = urlSearchParameters.get('shortTerm') === 'true';
        }
    }
    _invoiceIdObserver() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.invoiceId) {
                return;
            }
            this.isLoading = true;
            const loadInvoiceResult = yield MembersignupAPI.getV1BoostsignupInvoiceUsingInvoiceId(this.invoiceId);
            this.isLoading = false;
            if (isErrorHTTP(loadInvoiceResult)) {
                SnackBar.pushError(loadInvoiceResult.error);
                return;
            }
            this.invoice = loadInvoiceResult;
            this.isLoading = true;
            const paymentStatus = yield MembersignupAPI.getV2BoostsignupPaymentUsingInvoiceid(this.invoice.invoice.id);
            this.isLoading = false;
            if (isErrorHTTP(paymentStatus)) {
                SnackBar.pushError(paymentStatus.error);
                return;
            }
            this.paymentStatus = paymentStatus;
        });
    }
    _initiatePayment(paymentType) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.invoice || this.isLoading) {
                console.error('Mangler invoiceID');
                return;
            }
            const fallback = this._getFallbackUrl();
            this.isLoading = true;
            const vippsUrlRequest = yield MembersignupAPI.postV2BoostsignupInitiatepayment({
                paymentType,
                invoice_id: this.invoice.invoice.id,
                fallback,
            });
            this.isLoading = false;
            if (isErrorHTTP(vippsUrlRequest)) {
                console.error('Vipps payment initiation failed', vippsUrlRequest);
                return;
            }
            const { token: _token, checkout_url: _checkoutUrl, payment_url: paymentUrl } = vippsUrlRequest;
            if (!paymentUrl) {
                SnackBar.pushError('Mangler betalingslenke');
            }
            if (paymentUrl) {
                window.location.href = paymentUrl;
            }
        });
    }
    _getFallbackUrl() {
        var _a;
        const url = `${window.location.origin}/${this.centerShort}/betaling`;
        if (!url) {
            console.error('Mangler url');
            return '';
        }
        return `${url}?invoiceId=${(_a = this.invoice) === null || _a === void 0 ? void 0 : _a.invoice.id}&shortTerm=${this.shortTerm}`;
    }
    /** @override */ updated(changedProperties) {
        changedProperties.forEach((_oldValue, propertyName) => {
            switch (propertyName) {
                case 'invoiceId':
                    this._invoiceIdObserver();
                    break;
            }
        });
        super.updated(changedProperties);
    }
};
BoostPortalPaymentStatus._deps = [];
__decorate([
    property({ type: Number }),
    __metadata("design:type", Number)
], BoostPortalPaymentStatus.prototype, "invoiceId", void 0);
__decorate([
    state(),
    __metadata("design:type", Object)
], BoostPortalPaymentStatus.prototype, "invoice", void 0);
__decorate([
    state(),
    __metadata("design:type", Object)
], BoostPortalPaymentStatus.prototype, "paymentStatus", void 0);
__decorate([
    state(),
    __metadata("design:type", Boolean)
], BoostPortalPaymentStatus.prototype, "isLoading", void 0);
__decorate([
    state(),
    __metadata("design:type", Boolean)
], BoostPortalPaymentStatus.prototype, "shortTerm", void 0);
__decorate([
    reduxBind(BoostPortalStore.path('centerShort')),
    state(),
    __metadata("design:type", String)
], BoostPortalPaymentStatus.prototype, "centerShort", void 0);
BoostPortalPaymentStatus = __decorate([
    customElement(BoostPortalPaymentStatus.is)
], BoostPortalPaymentStatus);
export { BoostPortalPaymentStatus };
